import styles from './layout.module.scss'
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles'
import gsap from 'gsap'
import { useRouter } from 'next/router'

export const siteTitle = 'i3design'

const theme = createMuiTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 320,
      md: 1024,
      lg: 1025,
      xl: 1350,
    },
  },
})

const Layout: React.FC = ({ children }) => {
  const router = useRouter()

  const lpPages = [
    '/services/backend-dev',
    '/services/frontend-dev',
    '/services/designsystem',
    '/services/uiuxdesign-lp2',
    '/services/amazonecs',
    '/services/awsfargate',
    '/services/awsapprunner',
    '/services/gitlab',
    '/services/circleci',
    '/services/awscodepipeline',
    '/services/githubactions',
    '/services/zebra',
  ]

  const isLpPage = lpPages.includes(router.pathname)
  const isFlamingoPage = router.pathname.startsWith('/services/flamingo')

  gsap.config({
    nullTargetWarn: false,
  })

  return (
    <>
      {(() => {
        if (typeof window !== 'undefined') {
          window.addEventListener('unload', function () {
            window.scrollTo(0, 0)
          })
        }
      })()}
      <MuiThemeProvider theme={theme}>
        {!isFlamingoPage ? (
          <main className={`${styles.main} ${isLpPage ? styles.lpmain : ''}`}>{children}</main>
        ) : (
          <main className={`${styles.flamingo}`}>{children}</main>
        )}
      </MuiThemeProvider>
    </>
  )
}

export default Layout
